import { useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useAppSelector } from 'reduxTyped'
import { z } from 'zod'
import { l } from '@manychat/manyui'

import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { AiAlwaysOnAutomationsSelectors } from 'apps/aiAutomation/store/core'
import { TovReaction } from 'shared/api/requests/aiToneOfVoice/schemas'

export const useQuestionnaire = ({ onFinish }: { onFinish: (answers: TovReaction[]) => void }) => {
  const samples = useAppSelector(AiAlwaysOnAutomationsSelectors.getTovSamples)

  const [activeSample, setActiveSample] = useState(0)

  const [showCommentForm, setShowCommentForm] = useState(false)

  const [answers, setAnswers] = useState<TovReaction[]>([])

  const form = useForm({
    defaultValues: {
      user_reaction: '',
    },
    resolver: zodResolver(
      z.object({
        user_reaction: z
          .string()
          .min(5, l.translate('Provide more feedback to continue'))
          .max(
            1000,
            l.translate('Feedback must be {count} characters or fewer', {
              count: 1000,
            }),
          ),
      }),
    ),
  })

  const reset = () => {
    form.reset({
      user_reaction: '',
    })
  }

  const submitReaction = (is_reaction_positive: boolean, user_reaction: string | null = null) => {
    const { ai_reply, comment, post, reply } = samples[activeSample]

    const newAnswer: TovReaction = {
      is_reaction_positive,
      user_reaction,
      ai_reply,
      comment,
      post,
      reply,
    }

    const isLastSample = samples.length - 1 === activeSample

    if (isLastSample) {
      onFinish([...answers, newAnswer])
    } else {
      setAnswers((prev) => [...prev, newAnswer])
      setActiveSample((prev) => prev + 1)
      setShowCommentForm(false)
    }

    if (!is_reaction_positive) {
      reset()
    }
  }

  const submitLike = () => {
    AiAutomationAnalytics.logTovSampleRated({
      is_positive_reaction: true,
      sample_index: activeSample,
      user_reaction: null,
    })

    submitReaction(true)
  }

  const submitDislike = ({ user_reaction }: { user_reaction: string }) => {
    AiAutomationAnalytics.logTovSampleRated({
      is_positive_reaction: false,
      user_reaction,
      sample_index: activeSample,
    })

    submitReaction(false, user_reaction)
  }

  return {
    form,
    setShowCommentForm,

    samples,
    activeSample,
    showCommentForm,
    answers,
    submitLike,
    submitDislike,
    reset,
  }
}
